import React, { Component } from "react";

class Announcement extends Component {
	render() {
		return (
			<div id="annoucement" className="section-content">
				<h1>WE ARE GETTING MARRIED!!!</h1>
				<p className="lighter">
					We are delighted to invite you to the celebration of our marriage
				</p>
			</div>
		);
	}
}

export default Announcement;
